
      import API from "!../../react-forms/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../react-forms/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../react-forms/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../react-forms/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../react-forms/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../react-forms/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../react-forms/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./google-sign-in.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../react-forms/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./google-sign-in.css";
       export default content && content.locals ? content.locals : undefined;
